export const MuiStepper = {
  styleOverrides: {
    root: {
      width: '100%',
    },
  },
};
